import React from 'react';
import { Volleyball } from './Volleyball';
export function Footer() {
  return <footer className="bg-pilates-blue-dark text-white/70 py-10 px-4 text-center text-sm" data-id="element-108">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-109">
        <p className="flex items-center justify-center gap-2 font-display font-semibold text-white text-base tracking-wide" data-id="element-110">
          <Volleyball className="w-4 h-4 text-pilates-lavender" data-id="element-111" />©{' '}
          {new Date().getFullYear()} VolleyReady — All rights reserved.
        </p>
        <p className="text-xs text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-112">
          The content of this page is for informational and educational
          purposes. Please review the terms and conditions.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/60" data-id="element-113">
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-114">
            Terms & Conditions
          </a>
          <span data-id="element-115">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-116">
            Privacy Policy
          </a>
          <span data-id="element-117">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-118">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}